import produce from 'immer';
import { Dispatch } from 'redux';

import { user } from 'apis';

import { Action, ActionType, onboardingName, State } from './types';

export const initialState: State = {
  user: null,
  redirectAfterAuth: '/orders',
  onboardings: [
    {
      name: 'createOrder',
      isRunning: false,
      stepIndex: 0,
    },
  ],
};

export function fetchMe() {
  return async function (dispatch: Dispatch<Action>) {
    const response = await user.me();
    dispatch({ user: response, type: ActionType.SetUser });
  };
}

export function setRedirectRoute(route: string) {
  return { redirectAfterAuth: route, type: ActionType.SetRedirectRoute };
}

export function runOnboarding(onboardingName: onboardingName) {
  return { onboardingName, type: ActionType.RunOnboarding };
}

export function stopOnboarding(onboardingName: onboardingName) {
  return { onboardingName, type: ActionType.StopOnboarding };
}

export function onboardingNextStep(onboardingName: onboardingName) {
  return { onboardingName, type: ActionType.OnboardingNextStep };
}

export function onboardingPrevStep(onboardingName: onboardingName) {
  return { onboardingName, type: ActionType.OnboardingPrevStep };
}

export function setOnboardingStep(onboardingName: onboardingName, stepIndex: number) {
  return { setStep: { onboardingName, stepIndex }, type: ActionType.SetOnboardingStep };
}

export const getOnboarding = (state: State, onboardingName: onboardingName) =>
  state.onboardings.find(item => item.name === onboardingName)!;

export default function (state: State = initialState, action: Action) {
  const { user, type, onboardingName, setStep, redirectAfterAuth } = action;

  return produce<State>(state, (draft) => {
    switch (type) {
      case ActionType.SetUser:
        draft.user = user!;
        break;

      case ActionType.SetRedirectRoute:
        draft.redirectAfterAuth = redirectAfterAuth!;
        break;

      case ActionType.RunOnboarding:
        getOnboarding(draft, onboardingName!).isRunning = true;
        break;

      case ActionType.StopOnboarding:
        getOnboarding(draft, onboardingName!).isRunning = false;
        break;

      case ActionType.OnboardingNextStep:
        getOnboarding(draft, onboardingName!).stepIndex++;
        break;

      case ActionType.OnboardingPrevStep:
        getOnboarding(draft, onboardingName!).stepIndex--;
        break;

      case ActionType.SetOnboardingStep:
        getOnboarding(draft, setStep!.onboardingName).stepIndex = setStep!.stepIndex;
        break;
    }
  });
}
